
import * as _ from 'lodash';
import {BaseEntity} from "../common/base-entity";
import {TelephoneTypes} from "./telephone-types";
import {FormControl} from "rx-form-mapper";
import {Validators} from "@angular/forms";


const propertyIgnoreList = ['id'];

export class Telephone extends BaseEntity{

    constructor(telephone?: Telephone) {
        super(telephone);
        if (telephone) {
            for (let prop in telephone) {
                if (telephone.hasOwnProperty(prop)) {
                    this[prop] = telephone[prop];
                }
            }
        }
        if(!this.telephoneNumber){
            this.telephoneNumber = '';
        }
    }


    id?: string;
    @FormControl()
    telephoneNumber: string;

    phoneTypeCode: string;

    isPrimaryTelephone?: boolean;

    /** UI only field, temporarily stores UI value when the user is working with different phone options */
    localValue : string;

    get phoneWithLabel(): string {
        let label = '';
        switch (this.phoneTypeCode) {
            case 'HOME':
                label = 'h: ';
                break;
            case 'WORK':
                label = 'w: ';
                break;
            case 'MOBILE':
                label = 'c: ';
                break;
            case 'FAX':
                label = 'f: ';
                break;

        }
        return label + this.telephoneNumber;
    }

    static update(source: Telephone, target?: Telephone) : Telephone {
        if(source) {
            if(!target) {
                target = new Telephone();
            }
            target.telephoneNumber = source.telephoneNumber;
            target.phoneTypeCode = source.phoneTypeCode;
            target.isPrimaryTelephone = source.isPrimaryTelephone;

            return target;
        }

        return undefined;
    }

    shouldKeyBeChecked(key): boolean {
        // We only check if it is a normal data property
        return this.isNonBlackedKey(key, propertyIgnoreList) && super.shouldKeyBeChecked(key);
    }

    toStringForComparison(): string {
        return 'Type:' + this.phoneTypeCode + 'Number:' + this.telephoneNumber + "isPrimary:" + this.isPrimaryTelephone;
    }

    get capitalizedPhoneType(): string{
        if(this.phoneTypeCode){
            return _.capitalize(this.phoneTypeCode);
        }
        return this.phoneTypeCode;
    }

    get isWorkPhone(): boolean{
        return this.phoneTypeCode === TelephoneTypes.work;
    }

    get isCellPhone(): boolean{
        return this.phoneTypeCode === TelephoneTypes.cell;
    }

    get isHomePhone(): boolean{
        return this.phoneTypeCode === TelephoneTypes.home;
    }

    get isFaxPhone(): boolean{
        return this.phoneTypeCode === TelephoneTypes.fax;
    }

    get entityName() : string {
        return 'phone';
    }
}
